import { Component } from "@angular/core";
import { ViewController } from "ionic-angular";

@Component({
  selector: "encounters-popover",
  templateUrl: "encounters-popover.html",
})
export class EncountersPopoverComponent {
  text: string;

  constructor(public viewCtrl: ViewController) {
    console.log("Encounters Popover Component");
  }

  setFilter() {
    console.log("Set Filter Popover");
    this.viewCtrl.dismiss({ setFilter: true });
  }

  addEncounter($event) {
    console.log("Add Encounter Popover");
    this.viewCtrl.dismiss({ addEncounter: true });
  }

  downloadReport() {
    console.log("Download encounter Popover");
    this.viewCtrl.dismiss({ downloadReport: true });
  }

  createReport() {
    console.log("create encounter Popover");
    this.viewCtrl.dismiss({ createReport: true });
  }
}



// WEBPACK FOOTER //
// ./src/pages/assessment/visits/encounters/encounters-popover.ts